import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import de from './translations/de'
import en from './translations/en'
import fr from './translations/fr'
import hu from './translations/hu'
import id from './translations/id'
import it from './translations/it'
import nl from './translations/nl'
import { LanguageCode, LanguageOption } from './types'
import { CLIENT_CONFIG } from '../client/buildConfig'
import type { ClientConfig } from '../client/ClientProvider'

import dutchFlag from '../../assets/static/images/flags/dutch-flag.png'
import englishFlag from '../../assets/static/images/flags/english-flag.png'
import frenchFlag from '../../assets/static/images/flags/french-flag.png'
import germanFlag from '../../assets/static/images/flags/german-flag.png'
import hungarianFlag from '../../assets/static/images/flags/hungarian-flag.png'
import indonesianFlag from '../../assets/static/images/flags/indonesian-flag.png'
import italianFlag from '../../assets/static/images/flags/italian-flag.png'

export const defaultLanguage = 'nl'

export const languages: Record<LanguageCode, LanguageOption> = {
  en: { nameKey: 'languageNames.en', flag: englishFlag },
  nl: { nameKey: 'languageNames.nl', flag: dutchFlag },
  de: { nameKey: 'languageNames.de', flag: germanFlag },
  fr: { nameKey: 'languageNames.fr', flag: frenchFlag },
  it: { nameKey: 'languageNames.it', flag: italianFlag },
  hu: { nameKey: 'languageNames.hu', flag: hungarianFlag },
  id: { nameKey: 'languageNames.id', flag: indonesianFlag },
}

export const defaultAvailableLanguageCodes: LanguageCode[] = ['en', 'nl', 'de', 'fr', 'it']

export const clientLanguageCodes: LanguageCode[] = (
  (CLIENT_CONFIG as ClientConfig).languages ?? defaultAvailableLanguageCodes
).filter((code): code is LanguageCode => code in languages)

// Initialize i18n
i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en,
      },
      nl: {
        translation: nl,
      },
      de: {
        translation: de,
      },
      fr: {
        translation: fr,
      },
      it: {
        translation: it,
      },
      hu: {
        translation: hu,
      },
      id: {
        translation: id,
      },
    },
    fallbackLng: defaultLanguage,
    // Pin detection to the client's languages; without this, any globally registered
    // translation would auto-activate from the browser locale even for clients that don't list it.
    supportedLngs: clientLanguageCodes,
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
      defaultVariables: {
        // Client-configurable assistant name; falls back to the company name,
        // matching the document-title behavior in ClientProvider.
        assistantName:
          (CLIENT_CONFIG as ClientConfig).theme.branding.assistantName ??
          (CLIENT_CONFIG as ClientConfig).theme.branding.companyName,
      },
    },
  })

export default i18n
